exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-1481b43e]{margin-bottom:150px}.logo img[data-v-1481b43e]{margin-top:10px}.garage-pizza[data-v-1481b43e]{color:#212529}.text-top[data-v-1481b43e]{font-weight:inherit;text-align:right;font-size:1.5rem;color:#212529}.text-top strong[data-v-1481b43e]{font-size:1.75rem}.text-bottom[data-v-1481b43e]{font-weight:inherit;text-align:right;padding-right:20px;font-size:1.3rem}.text-bottom strong[data-v-1481b43e]{font-size:1.5rem}.text-bottom img[data-v-1481b43e]{height:40px;margin-top:-15px}@media (max-width:575.98px){.header[data-v-1481b43e]{background:#fff;margin-bottom:75px;padding:0 0 20px;border-top-right-radius:0;border-radius:50px;border-top-left-radius:0}.text-top[data-v-1481b43e]{text-align:left;margin-top:20px;margin-bottom:20px}.text-bottom[data-v-1481b43e]{padding-right:0;text-align:center}.logo img[data-v-1481b43e]{width:80%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1481b43e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 89
// module chunks = 0